import { styled } from 'theme';
import { Box } from '@mui/material';

export const MapIconContainer = styled(Box)(({ theme }) => ({
    'textAlign': 'center',
    'width': `${theme.spots.homeWidth}px`,
    'height': `${theme.spots.homeHeight}px`,
    'transition': `width ${theme.spots.transitionTime}, height ${theme.spots.transitionTime}`,
    'svg': {
        marginLeft: 'auto',
        marginRight: 'auto',
        width: `${theme.spots.homeWidth}px`,
        height: `${theme.spots.homeHeight}px`,
        color: theme.palette.primary.contrastText,
        display: 'table-cell',
        verticalAlign: 'baseline',
        transition: `width ${theme.spots.transitionTime}, height ${theme.spots.transitionTime}`,
    },
    '&:hover': {
        width: `${theme.spots.homeWidth * theme.spots.factor}px`,
        height: `${theme.spots.homeHeight * theme.spots.factor}px`,
        svg: {
            width: `${theme.spots.homeWidth * theme.spots.factor}px`,
            height: `${theme.spots.homeHeight * theme.spots.factor}px`,
        },
    },
}));
